export const iconFontAwesomeHumanitarianUserDoctor = (
	<i className="fa-solid fa-user-doctor"></i>
);
